import { fromFetch } from 'rxjs/fetch';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { VehicleFilterOptions } from '../models/vehicle-filter-options';
import { vehicleSchema } from '../schemas/vehicle.schema';

/**
 * Returns a paginated response for Vehicles
 * @param params Paged Collection Params
 * @returns Paged Collection of Vehicles
 */
export function getVehicles(
  this: unknown,
  params?: PagedCollectionParams,
  options?: VehicleFilterOptions
) {
  let requestUrl = `${fleetEnvironment.resolve(this).vehiclesUrl}?${
    params ? params.urlParams : ''
  }`;

  if (options) {
    if (typeof options.vehicleGroupName === 'string') {
      requestUrl += `&vehicleGroupName=${encodeURIComponent(
        options.vehicleGroupName
      )}`;
    } else if (typeof options.status === 'number') {
      requestUrl += `&vehicleGroupStatus=${options.status}`;
    }
  }

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(createPagedCollectionSchema(vehicleSchema)));
}
